export const access = {
    en: {
        welcome: 'Welcome to GS Trackme v3 App',
        title: 'GS Trackme',
        subtitle: 'Tracking your world',
        slides: [
            {
                file: 'live_view.png',
                title: 'New Feature: Live View Streaming',
                text: 'Live view streaming now available on our camera solution. Have more control of your fleet by checking in to see their driving in real time. Optimize the management of your fleet and make faster and more accurate decisions with this advanced feature. Additional cost may apply, contact us for more details.',
            },
			{
                file: 'cameras.png',
                title: 'Dash Cams',
                text: 'We’re now offering AI powered dash cameras. Contact your sales rep or reach out to us at +1 (801)-208-5543 for more info. Alternatively you may also email us at contact@gstrackme.com'
            },
			// {
            //     file: 'realtime.gif',
            //     title: 'Real-time tracking',
            //     text: 'Our platform allows you to observe in real time the exact location of your fleet, family or personal vehicles.'
            // },
            // {
            //     file: 'history.gif',
            //     title: 'Track history',
            //     text: 'Consult the history of streets traveled and movements made by the vehicle, as well as download the history file in PDF or Excel format.'
            // },
            // {
            //     file: 'reports.gif',
            //     title: 'Reports per period',
            //     text: 'We record data of maximum speeds, accelerations, engine on and off, stops and much more in the reports of your vehicles or fleet.'
            // },
            // {
            //     file: 'geofences.gif',   
            //     title: 'Unlimited geofences',
            //     text: 'Create as many geofences as you want. We can send you an alert for each entry and exit.'
            // },
            // {
            //     file: 'maintenance.gif',
            //     title: 'Maintenance Alerts',
            //     text: 'Receive alerts reminding you to perform the maintenance for your vehicles according to your custom schedule.'
            // },
            // {
            //     file: 'fuel.gif',
            //     title: 'Save fuel',
            //     text: 'GS Trackme will help you track routes, idle, and speed, all resulting in gas savings for your company.'
            // }
        ],
        inputs: {
            user: {
                icon: 'User',
                label: 'Username',
                required: "User is required",
                errors: {
                    notfound: 'The user does not exist',
                    inactive: 'The user is inactive',
                }
            },
            password: {
                icon: 'Password',
                label: 'Password',
                required: "Password is required",
                errors: {
                    notfound: 'Wrong password'
                }
            }
        },
        submit: 'LOGIN',
        forgot: { button: 'Forgot your password?', message: 'Please email with your company name or contact your account manager directly, thank you. <br><br><strong>USA: </strong><a href="mailto:contact@gstrackme.com">contact@gstrackme.com</a><br><strong>MEX: </strong><a href="mailto:contacto@gstrackme.com">contacto@gstrackme.com</a><br><strong>COL: </strong><a href="mailto:contacto@gstrackme.com">contacto@gstrackme.com</a>' },
        note: 'Do not have an account?',
        contact: 'Contact us',
        socials: [
            { icon: 'facebook', title: 'Facebook', link: 'https://www.facebook.com/gstrackmeusa' },
            { icon: 'youtube', title: 'Youtube', link: 'https://www.youtube.com/channel/UCW53IkN10D23KUB1xqKimOg' },
            { icon: 'in', title: 'LinkedIn', link: 'https://www.linkedin.com/company/gs-trackme-llc/' }
        ],
        link: 'https://gstrackme.com/en/contact.php',
        expired: {
            title: 'The session has expired',
            message: 'Sorry, your session has expired, please sign in again'
        },
        denied: {
            title: 'Access denied.',
            message: 'You do not have permissions to access this resource.',
            button: 'Close'
        },
        loading: 'Logging in...',
        payment: {
            title: "ATTENTION",
            invoices: ['Invoice', 'preInvoice', 'Due Date'],
            messages: {
                permitted: 'Due to outstanding account balance, your account will be locked in _DAYS_ day(s). Please send payment of full balance due to avoid your account from being locked. For questions or concerns, please call our customer service line at (801) 208 - 5543.',
                reject: `Due to outstanding account balance, your account has been locked. To unlock your account, please send payment of full balance due. Your account will remain active and billable during this time. Please call our customer service line at (801) 208-5543 for help`
            }
        },
        errors: {
            general: 'It seems to be taking longer than normal, if it continues like this contact your seller',
			nodevices: 'The account is active but has no assigned devices, if it continues like this, contact your seller',
        }
    },
    es: {
        welcome: 'Bienvenido a GS Trackme v3 App',
        title: 'GS Trackme',
        subtitle: 'Tracking your world',
        slides: [
            {
                file: 'ari.png',
                title: 'Optimiza tu Gestión Empresarial con ARI desde tan solo $25 al mes por empleado',
                text: `<p style="font-size: 0.93rem;">
                    Presentamos ARI, la más reciente innovación de 3Code, nuestra empresa hermana. 
                    Esta herramienta integral no solo se centra en la gestión de 
                    asistencias, sino que ofrece una solución completa para simplificar y potenciar tus 
                    procesos empresariales. Para obtener más información, no dudes en comunicarte al 9992975450 o visita su sitio web en 
                    <a style="color: antiquewhite;" target="_blank" href="https://www.arierp.com.mx">www.arierp.com.mx</a>.
                </p>`,
            },
            {
                file: "live_view.png",
                title: "Nueva función: Transmisión en vivo",
                text: 'Transmisión de visualización en vivo ahora disponible en nuestra solución de cámara. Tenga más control de su flota registrándose para ver su conducción en tiempo real. Optimice la gestión de su flota y tome decisiones más rápidas y precisas con esta función avanzada. Puede aplicarse un costo adicional, contáctenos para obtener más detalles.',
            },
			{
                file: 'cameras.png',
                title: 'Cámaras inteligentes de rastreo vehicular',
                text: 'Nuestro más reciente lanzamiento cámaras inteligentes de rastreo vehicular se encuentra ya disponible, para más información contacta con tu vendedor o búscanos enviando un correo a contacto@gstrackme.com o marcando el número 9992970288.'
            },
            // {
            //     file: "meet.png",
            //     title: "",
            //     text: 'Puedes unirte mediante el siguiente enlace',
            //     link: "http://bitly.ws/DfW4"
            // },
			// {
            //     file: 'realtime.gif',
            //     title: 'Rastreo en tiempo real',
            //     text: 'Nuestra plataforma le permite observar en tiempo real la ubicación exacta de los vehículos de su flotilla, familia o personales.'
            // },
            // {
            //     file: 'history.gif',
            //     title: 'Historial de recorridos',
            //     text: 'Consulte el historial de calles recorridas y movimientos realizados por el vehículo, así como descargar el archivo del historial en formato PDF o Excel.'
            // },
            // {
            //     file: 'reports.gif',
            //     title: 'Reportes por periodo',
            //     text: 'Registramos datos de velocidades máximas, aceleraciones, encendido y apagado de motor, paradas y mucho más en los reportes de sus vehículos o flotilla.'
            // },
            // {
            //     file: 'geofences.gif',
            //     title: 'Geocercas ilimitadas',
            //     text: 'Delimite zonas y nuestra plataforma emitirá una alerta de entrada y salida de la geocerca que seleccionó para su flotilla o vehículo particular.'
            // },
            // {
            //     file: 'maintenance.gif',
            //     title: 'Alertas de mantenimiento',
            //     text: 'Reciba alertas para recordar el mantenimiento de su vehículo o unidad de flotilla de acuerdo a un periodo seleccionado o kilometraje recorrido.'
            // },
            // {
            //     file: 'fuel.gif',
            //     title: 'Ahorre combustible',
            //     text: 'GS Trackme le ayudará a trazar, establecer y consultar rutas que le permitirán ahorrar en costos de gasolina para su vehículo.'
            // }
        ],
        inputs: {
            user: {
                icon: 'Usuario',
                label: 'Nombre de usuario',
                required: "Usuario es requerido",
                errors: {
                    notfound: 'El usuario no existe',
                    inactive: 'El usuario esta inactivo'
                }
            },
            password: {
                icon: 'Contraseña',
                label: 'Contraseña',
                required: "Contraseña es requerido",
                errors: {
                    notfound: 'La contraseña no coincide'
                }
            }
        },
        submit: 'INICIAR SESIÓN',
        forgot: { button: '¿Olvidaste tu contraseña?', message: 'Envíe por correo electrónico el nombre de su empresa o contacte con su administrador de cuenta directamente, gracias. <br><br><strong>USA: </strong><a href="mailto:contact@gstrackme.com">contact@gstrackme.com</a><br><strong>MEX: </strong><a href="mailto:contacto@gstrackme.com">contacto@gstrackme.com</a><br><strong>COL: </strong><a href="mailto:contacto@gstrackme.com">contacto@gstrackme.com</a>' },
        note: '¿No tienes una cuenta?',
        contact: 'Contáctanos',
        socials: [
            { icon: 'facebook', title: 'Facebook', link: 'https://www.facebook.com/GSTrackme/' },
            { icon: 'youtube', title: 'Youtube', link: 'https://www.youtube.com/channel/UCW53IkN10D23KUB1xqKimOg' },
            { icon: 'in', title: 'LinkedIn', link: 'https://www.linkedin.com/company/gs-trackme-mexico/' }
        ],
        link: 'https://gstrackme.com/es/contacto.php',
        expired: {
            title: 'La sesión ha expirado',
            message: 'Lo sentimos, tu sesión ha expirado, por favor vuelve a iniciar sesión'
        },
        denied: {
            title: 'Acceso denegado.',
            message: 'No tienes permisos para acceder a este recurso.',
            button: 'Cerrar'
        },
        loading: 'Iniciando sesión...',
        payment: {
            title: "ATENCIÓN",
            invoices: ['Factura', 'Pre-Factura', 'Vencimiento'],
            messages: {
                permitted: 'Estimado cliente, debido a un saldo pendiente, su cuenta será bloqueada en _DAYS_ dia(s). Favor de efectuar el pago correspondiente para que su cuenta no sea bloqueada. Para atención a clientes marque al (999) 322-7429.',
                reject: `Debido a un saldo pendiente su cuenta a sido bloqueada. Para desbloquear su cuenta tenga la amabilidad de efectuar su pago correspondiente. Su cuenta seguirá activa y facturable durante este periodo. Para atención a clientes favor de marcar al (999) 322-7429.`
            }
        },
        errors: {
            general: 'Parece que esta tardando mas de lo normal, si continua así ponte en contacto con tu vendedor',
			nodevices: 'La cuenta esta activa pero no tiene dispositivos asignados, si continua así ponte en contacto con tu vendedor',
        }
    }
};
